import React, { useEffect, useState } from "react"
import { getClassList } from "../../../services/Inventory/inventory"
import { Controller } from "react-hook-form"
import Select from "react-select"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const ClassList = ({
  control,
  name,
  onSelectChange,
  seriesId,
  disabled,
  target,
}) => {
  // const [isLoading, setIsLoading] = useState(true)
  const [classData, setClassData] = useState([])

  const loadOptions = async () => {
    const data = await getClassList(seriesId?.id)
    // setIsLoading(false)
    const series = data?.data?.classes?.map(dta => {
      return {
        label: dta?.class_code && ucfirst(dta.class_code),
        value: dta.id,
        ...dta,
      }
    })

    setClassData(series)
  }

  useEffect(() => {
    if (seriesId?.id !== undefined) {
      loadOptions()
    }
  }, [seriesId?.id])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={classData}
              placeholder={"Class"}
              // isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              isDisabled={disabled}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector(
                target ? target : ".modal"
              )}
            />
          )
        }}
      />
    </div>
  )
}

export default ClassList
